import { jsx } from "react/jsx-runtime";
import { forwardRef, useRef, useCallback, useEffect } from "react";
import { withThemeAndSize } from "../../withThemeAndSize/index.js";
import { cn as clsx } from "../../../helpers/react.js";
import { isFunction } from "../../../helpers/utils.js";
import '../../../assets/index26.css';const textArea = "_textArea_1ny32_1";
const noResize = "_noResize_1ny32_17";
const error = "_error_1ny32_43";
const s = {
  textArea,
  noResize,
  error
};
const TextArea = withThemeAndSize(
  forwardRef(
    ({ value: valueFromProps, className, onChange, onBlur, error: error2, resizeHeightOnOverflow = false, ...rest }, forwardedRef) => {
      const ref = useRef(null);
      const refToUse = forwardedRef || ref;
      const onChangeHandler = useCallback(
        (event) => {
          const parsedValue = event.target.value;
          const trimmedValue = parsedValue.trim();
          onChange == null ? void 0 : onChange({
            parsedValue,
            charCount: trimmedValue.length,
            event
          });
        },
        [onChange]
      );
      const onBlurHandler = useCallback(
        (event) => {
          const trimmedValue = event.target.value.trim();
          onBlur == null ? void 0 : onBlur(event);
          onChange == null ? void 0 : onChange({
            parsedValue: trimmedValue,
            charCount: trimmedValue.length,
            event
          });
        },
        [onBlur, onChange]
      );
      useEffect(() => {
        if (!resizeHeightOnOverflow || isFunction(refToUse)) {
          return;
        }
        const textarea = refToUse == null ? void 0 : refToUse.current;
        if (!textarea) {
          return;
        }
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      }, [refToUse, valueFromProps, resizeHeightOnOverflow]);
      return /* @__PURE__ */ jsx(
        "textarea",
        {
          ...rest,
          ref: refToUse,
          className: clsx(
            s.textArea,
            {
              [s.noResize]: resizeHeightOnOverflow,
              [s.error]: error2
            },
            className
          ),
          onBlur: onBlurHandler,
          onChange: onChangeHandler,
          value: valueFromProps
        }
      );
    }
  )
);
export {
  TextArea
};
